import { useContext } from "react";
import AuthContext from "../context/AuthContext";
import useEncryption from "./useEncryption";

function useAuthFetch() {
  const { logout } = useContext(AuthContext);
  const { encrypt, decrypt } = useEncryption()


  const customFetch = async (url, method, bodyContent) => {
    try {
      let options;

      if (method === "GET") {
        options = {
          method,
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
        }
      } else {
        const encryptedRequest = bodyContent ? await encrypt(bodyContent) : null
        options = {
          method,
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify({
            encryptedRequest
          })
        }
      }


      const fetchResponse = await fetch(url, options);
      if (fetchResponse.status === 401) {
        logout();
        return { response: null, status: 401, message: "Unauthorized" };
      }
      const responseJSON = await fetchResponse.json()
      
      // Handle non-encrypted error responses (like 400 validation errors)
      if (!responseJSON?.encryptedResponse) {
        // Plain JSON response (usually for error responses)
        return { 
          response: responseJSON, 
          status: fetchResponse.status, 
          message: responseJSON?.message || "An error occurred" 
        };
      }
      
      // Encrypted response (success responses)
      try {
        const response = await decrypt(responseJSON.encryptedResponse)
        return { response, status: fetchResponse.status, message: responseJSON?.message };
      } catch (decryptError) {
        console.error("Error decrypting response:", decryptError);
        // If decryption fails but we have a message, return it
        if (responseJSON?.message) {
          return { 
            response: null, 
            status: fetchResponse.status, 
            message: responseJSON.message 
          };
        }
        throw decryptError; // Re-throw if we can't handle it
      }
    } catch (error) {
      console.error("Error in fetch request:", error);
      // Return error info so frontend can handle it
      return { response: null, status: 500, message: error.message || "Network error occurred" };
    }
  };

  return customFetch;
}

export default useAuthFetch;
